import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-104">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-amber-50 rounded-[24px] p-8 md:p-12 text-center border border-amber-200 shadow-sm relative overflow-hidden" data-id="element-105">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300" data-id="element-106"></div>

        <div className="inline-flex justify-center items-center w-20 h-20 rounded-full bg-amber-100 mb-6" data-id="element-107">
          <ShieldCheck className="w-10 h-10 text-amber-500" data-id="element-108" />
        </div>

        <h2 className="text-3xl font-heading font-bold text-brand-dark mb-8" data-id="element-109">
          Tu inversión está 100% protegida
        </h2>

        <div className="bg-white rounded-[16px] p-6 md:p-8 shadow-sm border border-amber-100 mb-6" data-id="element-110">
          <h3 className="text-xl font-bold text-amber-600 mb-4 flex items-center justify-center gap-2" data-id="element-111">
            🛡️ GARANTÍA DE 7 DÍAS SIN PREGUNTAS
          </h3>
          <p className="text-brand-dark leading-relaxed mb-4" data-id="element-112">
            Si por cualquier razón sientes que esta guía no fue lo que
            esperabas, escríbenos dentro de los primeros 7 días y te devolvemos
            el 100% de tu dinero.
          </p>
          <p className="text-brand-dark font-medium mb-4" data-id="element-113">
            Sin cuestionarte. Sin formularios. Sin complicaciones.
          </p>
          <p className="text-brand-primary font-semibold" data-id="element-114">
            Así de seguros estamos de que esta guía va a superar tus
            expectativas. 💜
          </p>
        </div>

        <p className="text-sm text-brand-secondary italic" data-id="element-115">
          El riesgo es completamente nuestro. El conocimiento es completamente
          tuyo.
        </p>
      </motion.div>
    </section>;
}